export const ZENJOB_PURPLE_LOGO_ALT_TEXT = 'Zenjob Pro Logo Purple';
export const ZENJOB_ERROR_PIC_ALT_TEXT = 'Zenjob Pro Error Picture';
